export const envConfig = {
  authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL || "",
  graphqlBaseUrl: import.meta.env.VITE_GRAPHQL_BASE_URL || "",
  installerClientId: import.meta.env.VITE_INSTALLER_CLIENT_ID || "",
  installerAuthorizeUrl: import.meta.env.VITE_INSTALLER_AUTHORIZE_URL || "",
  installerTokenUrl: import.meta.env.VITE_INSTALLER_TOKEN_URL || "",
  installerLogoutUrl: import.meta.env.VITE_INSTALLER_LOGOUT_URL || "",
  installerScopes: import.meta.env.VITE_INSTALLER_SCOPES || "",
} as const;
